<template>
  <b-container fluid>
    <b-button block variant="danger" class="mb-1" @click.stop.prevent="showAll">Показать всех клиентов</b-button>
    <b-card border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <h5 slot="header">
        {{ item.clientName }}
      </h5>
      <b-table ref="selectableTable" v-if="items.length > 0" sticky-header="1000px" selectable selected-variant=""
               select-mode="multi"
               striped small bordered
               outlined primary-key="id" :items="items" :fields="fields" @row-selected="onRowSelected">
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-if="selected.length === 0" v-slot:head(selected)="data">
          <b-button size="sm" @click="selectAllRows"><span aria-hidden="true">&check;</span></b-button>
        </template>
        <template v-else v-slot:head(selected)="data">
          <b-button size="sm" @click="clearSelected"><span aria-hidden="true">&check;</span></b-button>
        </template>
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
      </b-table>
    </b-card>
    <Charts class="mt-3" ref="charts"/>
  </b-container>
</template>

<script>
import axios from 'axios';
import RealBiologicalAge from "./outputs/RealBiologicalAge.vue";
import SportAge from "./outputs/SportAge.vue";
import SOPFactor from "./outputs/SOPFactor.vue";
import RiskFactors from "./outputs/RiskFactors.vue";
import ODV from "./outputs/ODV.vue";
import MNT from "./outputs/MNT.vue";
import IAP from "./outputs/IAP.vue";
import SFP from "./outputs/SFP.vue";
import BasalMetabolicRate from "./outputs/BasalMetabolicRate";
import Charts from './Charts.vue'

export default {
  components: {
    Charts
  },
  props: {
    authorizationToken: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
    },
  },
  created: function () {
    axios.defaults.baseURL = 'https://l01s75qla5.execute-api.us-east-1.amazonaws.com/prod';
    axios.defaults.headers.common['Authorization'] = this.authorizationToken;
    this.readOnce();
    this.showTable();
  },
  data() {
    return {
      fields: [{
        key: 'selected',
        label: '',
        class: 'text-center',
        stickyColumn: true
      }, {
        key: 'requestDate',
        label: 'Дата',
        class: 'text-left'
      }, {
        key: 'requestTime',
        label: 'Время',
        class: 'text-left'
      }, {
        key: 'height',
        label: 'Рост, см',
        class: 'text-center'
      }, {
        key: 'weight',
        label: 'Вес, кг',
        class: 'text-center'
      }, {
        key: 'age',
        label: 'Возраст, лет',
        class: 'text-center'
      }, {
        key: 'bpsys',
        label: 'АДс, мм рт. ст.',
        class: 'text-center'
      }, {
        key: 'bpdia',
        label: 'АДд, мм рт. ст.',
        class: 'text-center'
      }, {
        key: 'hr',
        label: 'Пульс, уд/мин',
        class: 'text-center'
      }, {
        key: 'rr',
        label: 'ЧД, вдох/мин или ПСВ, л/мин',
        class: 'text-center'
      }, {
        key: 'ib',
        label: 'Пресс за 1\' + Отжимания за 1\'',
        class: 'text-center'
      }, {
        key: 'fbes',
        label: 'Локтевая планка',
        class: 'text-center'
      }, {
        key: 'realBiologicalAge',
        label: 'RBA, лет',
        class: 'text-center'
      }, {
        key: 'sportAge',
        label: 'Спорт. в-т, лет',
        class: 'text-center'
      }, {
        key: 'sopMuscleLevel',
        label: 'КрФ Ё-ть, %',
        class: 'text-center'
      }, {
        key: 'ksdMuscleLevel',
        label: 'Лактат. М-ть, %',
        class: 'text-center'
      }, {
        key: 'kyadMuscleLevel',
        label: 'Кислород. М-ть, %',
        class: 'text-center'
      }, {
        key: 'odv',
        label: 'Эф-ть Вост., %',
        class: 'text-center'
      }, {
        key: 'hrStart',
        label: 'Пульс старт',
        class: 'text-center'
      }, {
        key: 'hrEnd',
        label: 'Пульс финиш',
        class: 'text-center'
      }, {
        key: 'mnt',
        label: 'Мощность, %',
        class: 'text-center'
      }, {
        key: 'iap',
        label: 'ИЛП, уд/мин',
        class: 'text-center'
      }, {
        key: 'stScore',
        label: 'Оценка',
        class: 'text-center'
      }, {
        key: 'hrMin2',
        label: 'Пульс восст., уд/мин',
        class: 'text-center'
      }, {
        key: 'sfp',
        label: 'УФП, ед.',
        class: 'text-center'
      }, {
        key: 'bmr',
        label: 'BMR, ккал/день',
        class: 'text-center'
      }],
      items: [],
      selected: [],
      data: {
        site: this.item.site,
        clientLogin: this.item.id,
        clientName: this.item.clientName,
        height: 178,
        weight: 74,
        age: 35,
        bpsys: 120,
        bpdia: 75,
        hr: 68,
        rr: 16,
        ib: 25,
        fbes: 20,

        hrStart: 60,
        hrEnd: 110,

        stScore: 1,
        hrMin2: 120,
      },
      diagnosisTable: {},
      calculateEnable: false,
      recalculated: false,
      remainCount: -1,
    }
  },
  methods: {
    showAll() {
      this.$emit('showAll');
    },
    mergeData(data) {
      if (!(this.data.hrStart && this.data.hrEnd)) {
        this.data.hrStart = 60;
        this.data.hrEnd = 110;
      }
      if (!(this.data.stScore && this.data.hrMin2)) {
        this.data.stScore = 1;
        this.data.hrMin2 = 120;
      }
      this.data = Object.assign({}, this.data, data);
      this.diagnosisTable = Object.assign({}, this.diagnosisTable, data);
    },
    readOnce() {
      let data = this.data;
      this.data = {};
      let vm = this;
      axios.post('/cyberanalysis', {
        site: this.item.site,
        clientLogin: this.item.id,
      }).then(function (response) {
        vm.data = data;
        if (response.data.length > 0) {
          vm.mergeData(response.data[0]);
        }
        vm.data.site = vm.item.site;
      }).catch(function () {
        vm.data = data;
      });
    },
    doResponse(response) {
      if (response.data.length > 0) {
        let vm = this;
        vm.items.splice(0);
        response.data.forEach(function (item) {
          vm.items.push({
            id: item.requestTime,
            requestDate: new Date(item.requestTime).toLocaleDateString(),
            requestTime: new Date(item.requestTime).toLocaleTimeString(),
            height: item.height,
            weight: item.weight,
            age: item.age,
            bpsys: item.bpsys,
            bpdia: item.bpdia,
            hr: item.hr,
            rr: item.rr,
            ib: item.ib,
            fbes: item.fbes,
            realBiologicalAge: item.out.realBiologicalAge,
            sportAge: item.out.sportAge,
            sopMuscleLevel: item.out.sopMuscleLevel,
            ksdMuscleLevel: item.out.ksdMuscleLevel,
            kyadMuscleLevel: item.out.kyadMuscleLevel,
            odv: (100 - Math.max(0, Math.min(item.out.odv, 100))).toFixed(0),
            hrStart: item.hrStart,
            hrEnd: item.hrEnd,
            mnt: item.out2iap ? item.out2iap.mnt : '',
            iap: item.out2iap ? item.out2iap.iap : '',
            stScore: item.stScore,
            hrMin2: item.hrMin2,
            sfp: item.out3sfp ? item.out3sfp.sfp : '',
            bmr: item.out3sfp ? item.out3sfp.bmr : '',
            _cellVariants: {
              "realBiologicalAge": RealBiologicalAge.methods.variant(item),
              "sportAge": SportAge.methods.variant(item),
              "sopMuscleLevel": SOPFactor.methods.variant(item),
              "ksdMuscleLevel": RiskFactors.methods.variant(item.out.ksdMuscleLevel),
              "kyadMuscleLevel": RiskFactors.methods.variant(item.out.kyadMuscleLevel),
              "odv": ODV.methods.variant(item),
              "mnt": MNT.methods.variant(item),
              "iap": IAP.methods.variant(item),
              "sfp": SFP.methods.variant(item),
              "bmr": BasalMetabolicRate.methods.variant(item),
            }
          });
        });
      }
    },
    showTable() {
      axios.post('/cyberanalysis', {
        site: this.item.site,
        clientLogin: this.item.id,
        getChartItems: true,
      }).then(this.doResponse).then(this.selectAllRows).catch(this.clearSelected);
    },
    onRowSelected(items) {
      this.selected = items;
      if (items.length === 0) {
        this.$refs.charts.error();
      }
      else {
        this.$refs.charts.addDataToCharts(items);
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
      this.$refs.charts.error();
    },
  }
}
</script>

<style>
table.b-table[aria-busy='true'] {
  opacity: 0.6;
}
</style>